<div class="flex flex-col gap-y-2">
  @let vm = offshoreReportStore.vm();
  @if (vm.isSectionVisible('stock', 'tankStockTable')) {
    <re-tank-stock-table id="tankStockTable" />
    <p-divider />
  }

  @if (vm.isSectionVisible('stock', 'tanks')) {
    <re-tank-transfers id="tankTransfers"></re-tank-transfers>
    <p-divider />
  }

  @if (vm.isSectionVisible('stock', 'rob')) {
    <re-fuel-rob id="fuelROB" />
    <p-divider />
  }

  @if (stockStore.dynamicSection()) {
    <re-dynamic-form
      tabId="stock"
      [events]="events"
      [formConfig]="
        offshoreReportStore.formConfig()?.tabs?.['stock']?.customFields ?? []
      "
      [storeSectionState]="stockStore.dynamicSection()"
      class="flex flex-col gap-y-2"
    ></re-dynamic-form>
  }
</div>
